import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { SmartOfficeContactSyncSettings } from './SmartOfficeContactSyncSettings'

export const SmartOfficeSpecificSettings = (): ClickNavigationProps[] => {
  return [
    { id: 'contactSync', label: 'Contact Sync', content: () => <SmartOfficeContactSyncSettings /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={IntegrationServiceId.SMARTOFFICE} /> },
  ]
}
